export default __webpack_public_path__ + "static/kv_pc_h264-16dd821e1fd3cffb94f51715226c267a.mp4";